<div class="mtn-title">
    <p>CONFIRMATION MESSAGE</p>
</div>
<div class="msg">
    <span>You have unsaved changes. Do you want to continue?</span>
</div>
<div class="btn-grp-2 btn-grp-2-l">
    <button class="btn btn2" type="button" mat-dialog-close  (click)='onYes()'>YES</button>
    <button class="btn btn4" type="button" mat-dialog-close  (click)='onNo()'>NO</button>
</div> 